import CryptoJS from "crypto-js";

const state = {
  showOtp: false,
  storeOffline: false,
  okey: false,
  advancedTemplate: false,
  domain: false,
};

const getters = {
  showOtp: () => {
    return state.showOtp;
  },
  storeOffline: () => {
    return state.storeOffline;
  },
  okey: () => {
    return state.okey;
  },
  advancedTemplate: () => {
    return state.advancedTemplate;
  },
  domain: () => {
    return state.domain;
  },
};

const actions = {
  setShowOtp({commit}, payload) {
    return commit('setShowOtp', payload);
  },
  setOkey({commit}, payload) {
    return commit('setOkey', payload);
  },
  setStoreOffline({commit}, payload) {
    return commit('setStoreOffline', payload);
  },
  setAdvancedTemplate({commit}, payload) {
    return commit('setAdvancedTemplate', payload);
  },
  setDomain({commit}, payload) {
    return commit('setDomain', payload);
  },
  clearState({commit}) {
    return commit('clearState');
  },
};

const mutations = {
  clearState(state) {
    state.showOtp = false;
    state.storeOffline = false;
    state.okey = false;
    state.advancedTemplate = false;
    state.domain = false;
  },
  setOkey(state, payload) {
    state.okey = payload;
  },
  encryptOkey(state, payload) {
    state.okey = CryptoJS.SHA512(payload + state.domain).toString(CryptoJS.enc.Hex);
  },
  setDomain(state, payload) {
    state.domain = payload.toLowerCase();
  },
  setShowOtp(state, status) {
    state.showOtp = status;
    localStorage.setItem('showOtp', status);
  },
  setStoreOffline(state, status) {
    state.storeOffline = status;
    if (!status) {
      state.okey = null;
    }
  },
  setAdvancedTemplate(state, status) {
    state.advancedTemplate = status;
    localStorage.setItem('advancedTemplate', status);
  },
  loadOffline(state, store) {
    state.showOtp = store.showOtp;
    state.storeOffline = store.storeOffline;
    state.okey = store.okey;
    state.advancedTemplate = store.advancedTemplate;
    state.domain = store.domain;
  },
  setLoggedIn(state, status) {
    state.loggedin = status;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/settings.js